import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { ReportParams } from '../models/resource/reporting.resource';

@Injectable({ providedIn: 'root' })
export class ReportingSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public generateReportData(params: ReportParams): Observable<{pivotLabel: string, data : Record<string, string>[]}> {
		return this.makeHttpRequest('post', 'api2/report', params);
	}
}
